/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setReportProperties } from 'state/actions/reportsState/selected_report_status';
// component
import Metrics from 'pages/dashboard/reports/detail/metrics/metrics';



/* ========== ~~~~~~~~~~ REPORT METRICS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ reportsState }) => ({
    viewType: reportsState.selectedReportStatus.selectedReportData.viewType,
    metrics: reportsState.selectedReportStatus.selectedReportData.metrics,
    valid: reportsState.selectedReportStatus.selectedReportData.selectedReportDataValid
});

// map actions
const mapDispatchToProps = dispatch => ({
    setReportProperties: data => dispatch(setReportProperties(data))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Metrics);